import React from 'react';
import classnames from 'classnames';

// Hooks
import useWindowDimensions from 'Wpds/hooks/useWindowDimensions';
import { useToggle } from 'Shared/utils/hooks';

// Components
import WpIcon from 'Wpds/components/icon/WpIcon';
import { WpButton } from 'Wpds/components/button';
import { WpModal, WpModalHeader, WpModalFooter, WpModalBody } from 'Wpds/components/modal';
import UserFilters from './UserFilter';
import StatusFilter from './StatusFilter';
import CompletionFilter from './CompletionFilter';
import DepartmentFilter from './DepartmentFilter';

// Styles
import './FiltersContainer.scss';

type Props = {
  handleAddFilter: Function;
  handleRemoveFilter: Function;
  selectedFilters: Array<any>;
  showUserFilter?: boolean;
  showCompletionFilter?: boolean;
  showStatusFilter?: boolean;
  showDepartmentFilter?: boolean;
};

const FiltersContainer = ({
  handleAddFilter,
  handleRemoveFilter,
  selectedFilters,
  showUserFilter = true,
  showCompletionFilter = true,
  showStatusFilter = true,
  showDepartmentFilter = true,
}: Props) => {
  const [isModalOpen, toggleIsModalOpen] = useToggle(false);

  const { width: windowWidth } = useWindowDimensions();
  const showCondensedFilters = windowWidth < 1200;

  const hasFilters = selectedFilters.length > 0;

  const baseClassName = 'FiltersContainer';
  const classes = classnames(baseClassName, showCondensedFilters && `${baseClassName}--condensed`);

  const filters = (
    <div className={classes}>
      {showUserFilter && (
        <div className={`${baseClassName}__filter-dropdown`}>
          <UserFilters addFilter={handleAddFilter} selectedFilters={selectedFilters} />
        </div>
      )}
      {showCompletionFilter && (
        <div className={`${baseClassName}__filter-dropdown`}>
          <CompletionFilter
            addFilter={handleAddFilter}
            selectedFilters={selectedFilters}
            handleRemoveFilter={handleRemoveFilter}
          />
        </div>
      )}
      {showStatusFilter && (
        <div className={`${baseClassName}__filter-dropdown`}>
          <StatusFilter
            addFilter={handleAddFilter}
            selectedFilters={selectedFilters}
            handleRemoveFilter={handleRemoveFilter}
          />
        </div>
      )}
      {showDepartmentFilter && (
        <div className={`${baseClassName}__filter-dropdown`}>
          <DepartmentFilter
            addFilter={handleAddFilter}
            selectedFilters={selectedFilters}
            handleRemoveFilter={handleRemoveFilter}
          />
        </div>
      )}
    </div>
  );

  if (showCondensedFilters) {
    return (
      <>
        <div className={`${baseClassName}__filter-dropdown`}>
          <WpButton size="sm" variant={hasFilters ? 'primary' : 'tertiary'} onClick={toggleIsModalOpen}>
            <WpIcon name="filter" />
            Filters {hasFilters && <>({selectedFilters.length})</>}
          </WpButton>
        </div>
        <WpModal isOpen={isModalOpen} onToggle={toggleIsModalOpen} size="sm">
          <WpModalHeader>Filters</WpModalHeader>
          <WpModalBody>{filters}</WpModalBody>
          <WpModalFooter>
            <WpButton onClick={toggleIsModalOpen}>Close</WpButton>
          </WpModalFooter>
        </WpModal>
      </>
    );
  }

  return <>{filters}</>;
};

export default FiltersContainer;
